export default __webpack_public_path__ + "static/media/CRC.938f134e.svg";